"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendMessage;
exports.SEND_MESSAGE = void 0;
var SEND_MESSAGE = 'WEB_CHAT/SEND_MESSAGE';
exports.SEND_MESSAGE = SEND_MESSAGE;

function sendMessage(text, method) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      channelData = _ref.channelData;

  return {
    type: SEND_MESSAGE,
    payload: {
      channelData: channelData,
      method: method,
      text: text
    }
  };
}